// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseManagement__progress-container {
  position: relative;
  min-height: 80px;
  display: block;
}
@media print {
  .CaseManagement__progress-container {
    display: none;
  }
}

.CaseManagement__progress-steps {
  height: 20px;
  position: relative;
  display: block;
  clear: both;
  margin: 0 0 2em 0;
  background: #BAE3E1;
  background-clip: content-box;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  padding: 6px;
}
.CaseManagement__progress-steps span {
  display: block;
  height: 100%;
  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #00bec0), color-stop(1, #00bec0));
  background-image: -moz-linear-gradient(center bottom, #00bec0 37%, #00bec0 69%);
  position: relative;
  overflow: hidden;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
@media only screen and (max-width: 480px) {
  .CaseManagement__progress-steps span {
    width: 50% !important;
  }
}

.CaseManagement__progress-steps-complete {
  background: #00bec0;
  background-clip: content-box;
}

ul.CaseManagement__section-nav {
  padding: 0;
  margin: 0;
  top: -13px;
  left: 0;
  position: absolute;
  width: 100%;
}
ul.CaseManagement__section-nav li {
  color: #1A1A1A;
  line-height: 40px;
  padding: 0;
  text-align: center;
  width: 16%;
  min-height: 60px;
  z-index: 10;
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-size: 1.125rem;
  font-weight: 700;
}
ul.CaseManagement__section-nav li.CaseManagement__current {
  color: #1A1A1A;
  font-weight: bold;
}
@media only screen and (max-width: 480px) {
  ul.CaseManagement__section-nav li.CaseManagement__current {
    display: inline-block;
    width: 100% !important;
  }
}
ul.CaseManagement__section-nav li.CaseManagement__current span.CaseManagement__dot {
  height: 50px;
  width: 50px;
  background-color: #00bec0;
  border-radius: 50%;
  display: inline-block;
  border: solid;
  border-width: thick;
  border-color: #00bec0;
}
ul.CaseManagement__section-nav li.CaseManagement__active {
  color: #1A1A1A;
  font-weight: bold;
}
@media only screen and (max-width: 480px) {
  ul.CaseManagement__section-nav li.CaseManagement__active {
    display: none;
  }
}
ul.CaseManagement__section-nav li.CaseManagement__active span.CaseManagement__dot {
  height: 50px;
  width: 50px;
  background-color: #00bec0;
  border-radius: 50%;
  display: inline-block;
  border: solid;
  border-width: thick;
  border-color: #00bec0;
}
@media only screen and (min-width: 480px) {
  ul.CaseManagement__section-nav li {
    display: inline-block;
  }
}
@media only screen and (max-width: 480px) {
  ul.CaseManagement__section-nav li {
    display: none;
  }
}
ul.CaseManagement__section-nav li span.CaseManagement__dot {
  height: 50px;
  width: 50px;
  background-color: #BAE3E1;
  border-radius: 50%;
  display: inline-block;
  border: solid;
  border-width: thick;
  border-color: #BAE3E1;
}`, "",{"version":3,"sources":["webpack://./node_modules/acma-spa/dist/layout/ProgressBar.scss"],"names":[],"mappings":"AAKA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAMI;EALJ;IAMQ,aAAA;EAHN;AACF;;AAMA;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAHJ;AAKI;EACI,cAAA;EACA,YAAA;EACA,iHAAA;EACA,+EAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA;EACA,mBAAA;AAHR;AAKQ;EAXJ;IAYQ,qBAAA;EAFV;AACF;;AAMA;EACI,mBA9CmB;EA+CnB,4BAAA;AAHJ;;AAMA;EACI,UAAA;EACA,SAAA;EACA,UAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AAHJ;AAKI;EACI,cAzDgB;EA0DhB,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAEA,gBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAJR;AAMQ;EACI,cAtEmB;EAuEnB,iBAAA;AAJZ;AAMY;EAJJ;IAKQ,qBAAA;IACA,sBAAA;EAHd;AACF;AAOgB;EACI,YAAA;EACA,WAAA;EACA,yBAtFG;EAuFH,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBA3FG;AAsFvB;AAUQ;EACI,cA9FmB;EA+FnB,iBAAA;AARZ;AAUY;EAJJ;IAKQ,aAAA;EAPd;AACF;AAWgB;EACI,YAAA;EACA,WAAA;EACA,yBA7GG;EA8GH,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAlHG;AAyGvB;AAaQ;EA5DJ;IA6DQ,qBAAA;EAVV;AACF;AAWQ;EA/DJ;IAgEQ,aAAA;EARV;AACF;AAYY;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAVhB","sourcesContent":["$AU-color-progress-bg: #00bec0;\r\n$AU-color-progress-border:#cccccc;\r\n$AU-color-progress-text:#1A1A1A;\r\n$AU-color-progress-text-active:#1A1A1A;\r\n\r\n.progress-container {\r\n    position: relative;\r\n    min-height: 80px;\r\n    display: block;\r\n\r\n    @media print {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.progress-steps {\r\n    height: 20px;\r\n    position: relative;\r\n    display: block;\r\n    clear: both;\r\n    margin: 0 0 2em 0;\r\n    background: #BAE3E1;\r\n    background-clip: content-box;\r\n    -moz-border-radius: 10px;\r\n    -webkit-border-radius: 10px;\r\n    border-radius: 10px;\r\n    padding: 6px;\r\n\r\n    span {\r\n        display: block;\r\n        height: 100%;\r\n        background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0,$AU-color-progress-bg),color-stop(1,$AU-color-progress-bg));\r\n        background-image: -moz-linear-gradient(center bottom,$AU-color-progress-bg 37%,$AU-color-progress-bg 69%);\r\n        position: relative;\r\n        overflow: hidden;\r\n        -webkit-border-radius: 10px;\r\n        -moz-border-radius: 10px;\r\n        border-radius: 10px;\r\n\r\n        @media only screen and (max-width: 480px) {\r\n            width: 50% !important;\r\n        }\r\n    }\r\n}\r\n\r\n.progress-steps-complete {\r\n    background: $AU-color-progress-bg;\r\n    background-clip: content-box;\r\n}\r\n\r\nul.section-nav {\r\n    padding: 0;\r\n    margin: 0;\r\n    top: -13px;\r\n    left: 0;\r\n    position: absolute;\r\n    width: 100%;\r\n\r\n    li {\r\n        color: $AU-color-progress-text;\r\n        line-height: 40px;\r\n        padding: 0;\r\n        text-align: center;\r\n        width: 16%;\r\n        //font-size: 1rem;\r\n        min-height: 60px;\r\n        z-index: 10;\r\n        font-family: \"Montserrat\", sans-serif;\r\n        font-size: 18px;\r\n        font-size: 1.125rem;\r\n        font-weight: 700;\r\n    \r\n        &.current {\r\n            color: $AU-color-progress-text-active;\r\n            font-weight: bold;\r\n\r\n            @media only screen and (max-width: 480px) {\r\n                display: inline-block;\r\n                width: 100% !important;\r\n            }\r\n\r\n            span {\r\n\r\n                &.dot {\r\n                    height: 50px;\r\n                    width: 50px;\r\n                    background-color: $AU-color-progress-bg;\r\n                    border-radius: 50%;\r\n                    display: inline-block;\r\n                    border:solid;\r\n                    border-width: thick;\r\n                    border-color: $AU-color-progress-bg;\r\n               }\r\n            }\r\n        }\r\n    \r\n        &.active {\r\n            color: $AU-color-progress-text-active;\r\n            font-weight: bold;\r\n\r\n            @media only screen and (max-width: 480px) {\r\n                display: none;\r\n            }\r\n\r\n            span{\r\n\r\n                &.dot {\r\n                    height: 50px;\r\n                    width: 50px;\r\n                    background-color: $AU-color-progress-bg;\r\n                    border-radius: 50%;\r\n                    display: inline-block;\r\n                    border:solid;\r\n                    border-width: thick;\r\n                    border-color: $AU-color-progress-bg;\r\n                }\r\n            }\r\n        }\r\n        @media only screen and (min-width: 480px){\r\n            display: inline-block;\r\n        }\r\n        @media only screen and (max-width: 480px) {\r\n            display: none;\r\n        }\r\n\r\n        span {\r\n\r\n            &.dot {\r\n                height: 50px;\r\n                width: 50px;\r\n                background-color: #BAE3E1;\r\n                border-radius: 50%;\r\n                display: inline-block;\r\n                border:solid;\r\n                border-width: thick;\r\n                border-color: #BAE3E1;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress-container": `CaseManagement__progress-container`,
	"progress-steps": `CaseManagement__progress-steps`,
	"progress-steps-complete": `CaseManagement__progress-steps-complete`,
	"section-nav": `CaseManagement__section-nav`,
	"current": `CaseManagement__current`,
	"dot": `CaseManagement__dot`,
	"active": `CaseManagement__active`
};
export default ___CSS_LOADER_EXPORT___;
